import { OUTLAW_COMMUNITY_CONFIG, OutlawCommunityConfig } from '../outlaw-community.config';
import { buildCommunityConfig } from '../generators/community-config.generator';
import { provideDialogConfig } from '@ngneat/dialog';
import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { provideCommunityApi } from './community-api.provider';
import { provideSnackbarContainer } from './snackbar-container.provider';
import { provideCommunityRoutes } from './community-route.provider';

export function provideCommunity(config: OutlawCommunityConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideCommunityConfig(config),
    provideDialogConfig({
      closeButton: false,
    }),
    provideLottieOptions({ player: () => player }),
    provideCommunityApi(config.baseUrl),
    provideSnackbarContainer(),
    provideCommunityRoutes(),
  ]);
}

export function provideCommunityConfig(config: Partial<OutlawCommunityConfig>): Provider[] {
  return [
    {
      provide: OUTLAW_COMMUNITY_CONFIG,
      useValue: buildCommunityConfig(config),
    },
  ];
}
